import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'atsArrayHasItem',
    standalone: false
})
export class AtsArrayHasItemPipe implements PipeTransform {
	transform(itemId: string, ids: string[]): boolean {
		return ids.some(id => id === itemId);
	}
}
